import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';

import { workflowTemplatesApi } from '@/lib/api/workflow-templates.api';

import type { CreateWorkflowTemplateDto, UpdateWorkflowTemplateDto } from '@repo/shared-types';

const QUERY_KEY = ['workflow-templates'];

export const useWorkflowTemplates = () =>
  useQuery({ queryKey: QUERY_KEY, queryFn: workflowTemplatesApi.getAll });

export const useCreateWorkflowTemplate = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: CreateWorkflowTemplateDto) => workflowTemplatesApi.create(data),
    onSuccess: () => qc.invalidateQueries({ queryKey: QUERY_KEY }),
  });
};

export const useUpdateWorkflowTemplate = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateWorkflowTemplateDto }) =>
      workflowTemplatesApi.update(id, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: QUERY_KEY }),
  });
};

export const useDeleteWorkflowTemplate = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => workflowTemplatesApi.delete(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: QUERY_KEY }),
  });
};
